/**
 * FoodPulseSlogan — tiny, on-brand slogan chip for FoodPulse section heros.
 *
 * Usage:
 *   <FoodPulseSlogan surface="about" />
 *   <FoodPulseSlogan surface="businesses" size="lg" />
 *
 * Pulls the string from `foodPulseSlogans.js` so every section stays
 * in sync when the marketing copy is tweaked.
 */
import { foodPulseSlogan } from "@/config/foodPulseSlogans";
import { Sparkles } from "lucide-react";

export default function FoodPulseSlogan({
  surface = "home",
  size = "md",
  className = "",
  hideIcon = false,
  testId = null,
}) {
  const line = foodPulseSlogan(surface);
  const isLg = size === "lg";
  return (
    <div
      className={`inline-flex items-center gap-1.5 ${
        isLg ? "text-sm" : "text-[11px]"
      } font-mono uppercase tracking-widest ${className}`}
      style={{ color: "#B25D38" }}
      data-testid={testId || `fp-slogan-${surface}`}
    >
      {!hideIcon && <Sparkles className={isLg ? "w-4 h-4" : "w-3 h-3"} aria-hidden="true" />}
      <span>{line}</span>
    </div>
  );
}
